
import { Component, Mixins } from "vue-property-decorator";
import format from "date-fns/format";
import { CommentEntry } from "@/interfaces/meeting/details";
import CartMixin from "@/mixins/CartMixin.vue";

@Component
export default class CommentMixin extends Mixins<CartMixin>(CartMixin) {
  comment = "";
  savingComment = false;
  displayCommentsDialog = false;
  savedComments: CommentEntry[] = [];

  async saveComment(e: KeyboardEvent) {
    if (!e.shiftKey && this.comment.trim()) {
      this.savingComment = true;
      await this.apiClient.post("meeting_activity", {
        kind: "MEETING_COMMENT",
        comment: this.comment
      });
      this.savedComments.push({
        comment: this.comment,
        when: format(new Date(), "h:mm aa")
      });
      this.savingComment = false;
      this.comment = "";
    }
  }
}
